<template>
  <a class="home-group-card" :href="groupUrl" @click.prevent="$emit('select')">
    <div
      class="home-group-card-image"
      :style="imageUrl ? { backgroundImage: `url('${imageUrl}')` } : undefined"
    />
    <div class="home-group-card-body">
      <h3 class="home-group-card-title">{{ name }}</h3>
      <p v-if="city" class="home-group-card-city">{{ city }}</p>
      <p class="home-group-card-members">{{ $tc('member', memberCount) }}</p>
    </div>
  </a>
</template>

<script>
export default {
  name: 'HomeGroupCard',
  props: {
    groupId: {
      type: Number,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    city: {
      type: String,
      required: false,
      default: ''
    },
    memberCount: {
      type: Number,
      required: false,
      default: 0
    },
    imageUrl: {
      type: String,
      required: false,
      default: null
    }
  },
  computed: {
    groupUrl() {
      return `/groups/${this.groupId}`
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/variables.scss';

.home-group-card {
  display: block;
  background: #fff;
  border: 1px solid #ececec;
  border-radius: 14px;
  overflow: hidden;
  color: inherit;
  text-decoration: none;
  transition: box-shadow 0.18s, transform 0.18s;

  &:hover {
    box-shadow: 0 10px 28px rgba(68, 74, 73, 0.1);
    transform: translateY(-2px);
    color: inherit;
    text-decoration: none;
  }
}

.home-group-card-image {
  height: 120px;
  background-color: #edf1f0;
  background-size: cover;
  background-position: center;
}

.home-group-card-body {
  padding: 1rem 1.125rem 1.125rem;
}

.home-group-card-title {
  margin: 0;
  font-size: 0.9375rem;
  font-weight: 600;
  color: $ipBlack;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.home-group-card-city {
  margin: 0.125rem 0 0;
  font-size: 0.8125rem;
  color: $ipGreyDark;
}

.home-group-card-members {
  margin: 0.375rem 0 0;
  font-size: 0.8125rem;
  color: $ipGreyLight;
}
</style>
